import { Dropdown } from "antd";
import styled from "styled-components";

export default styled(Dropdown).attrs({ overlayStyle: { minWidth: 150 }, trigger: ["click"] })``;
